import React from 'react';
import './Section7.css';

import Service from '../../../assets/images/Reason/CustomerService.png';
import Cost from '../../../assets/images/Reason/CostEffective.png';
import Durability from '../../../assets/images/Reason/Durability.png';
import Customization from '../../../assets/images/Reason/Customization.png';





const reasonsData = [
  {
    id: 1,
    logo: Durability,
    title: 'Durability',
    description: 'Our products are built to last, ensuring that our designs stand the test of time.',
  },
  {
    id: 2,
    logo: Customization,
    title: 'Customization',
    description: 'We offer a wide range of customization options to meet your specific needs.',
  },
  {
    id: 3,
    logo: Service,
    title: 'Quick customer service',
    description: 'Experience quick and responsive customer service to help with all your needs.',
  },
  {
    id: 4,
    logo: Cost,
    title: 'Cost-effective',
    description: 'Enjoy high-quality services at variable prices, offering great value for money.',
  },
];

const HomeSection7 = () => {
  return (
    <section className="reasons-section">
      <div className="reasons-container">
        <h2>Reasons to get printing started with us</h2>
        <p className="intro-text">
          Our dedicated staff makes it easy to create unique designs that will impress our clients and make us stand out from the crowd.
        </p>
        <div className="reasons-grid">
          {reasonsData.map((reason) => (
            <div key={reason.id} className="reason-item">
              <img src={reason.logo} alt={`reasons Logo`} className="reason-logo" />
              <h3>{reason.title}</h3>
              <p>{reason.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default HomeSection7;